import React from 'react';

import { Form, Formik, FormikProps } from 'formik';

import SearchFieldAuto from '@app/components/Forms/SearchField/SearchFieldAuto';
import { SidebarProps } from '@app/objects/SidebarProps';

import '@app/scss/components/blockSideBar.scss';

const Sidebar: React.FC<SidebarProps> = ({
	searchFieldName,
	searchFieldPlaceHolder,
	onSetIssue,
	currentIndex,
	navCollapse,
	topics,
	withSubmit,
	submitCaption,
	typeButton = 'submit',
	vetId,
	setStateSelected,
	stateSelected,
	setVetId,
	setVetName,
	setVetNameShort,
	vetFieldValue,
	vetNameShort,
	setVetFieldValue,
	stateListOptions,
	vetListOptions,
	vetNameListOptions,
	setCardsCount,
	onSubmit,
	initCardsCount,
	setTypeSelected,
	setCurrentIndex,
	vetName,
}) => {
	const [isOpen, setIsOpen] = React.useState(false);

	const callMenu = () => {
		setIsOpen(!isOpen);
	};

	const clearSelected = (formikBag) => {
		setStateSelected && setStateSelected('');
		setVetId && setVetId('');
		setVetName && setVetName('');
		setVetNameShort && setVetNameShort('');
		setCardsCount && initCardsCount && setCardsCount(initCardsCount);
		setVetFieldValue && setVetFieldValue('');
		setTypeSelected && setTypeSelected('');
		setCurrentIndex && setCurrentIndex(0);
		formikBag.resetForm(formikBag.initialValues);
	};

	return (
		<div className="block__sidebar">
			<Formik
				onSubmit={(values) => {
					onSubmit && onSubmit();
				}}
				initialValues={{ state: stateSelected || '', vetById: vetFieldValue || '', vetByName: vetName || '' }}
				enableReinitialize
			>
				{(formikBag: FormikProps<any>) => {
					return (
						<Form autoComplete="off">
							<SearchFieldAuto
								name={searchFieldName}
								placeholder={searchFieldPlaceHolder}
								listOptions={vetNameListOptions}
								formikBag={formikBag}
								onSelect={(value, option) => {
									setVetName && setVetName(option.value.slice(4));
								}}
								onChange={(value, option) => {
									formikBag.setFieldValue(searchFieldName, value);
									setVetNameShort && setVetNameShort(value);
								}}
								onSearch={() => {
									setVetName && formikBag.values[searchFieldName].substring(0, 4) === 'Dr. '
										? setVetName(formikBag.values[searchFieldName].slice(4))
										: setVetName && setVetName(formikBag.values[searchFieldName]);
								}}
								searchButton
							/>
							<div className={isOpen ? 'block__sidebar-nav active-mobile' : 'block__sidebar-nav'}>
								{topics && (
									<>
										<div className="block__sidebar-nav-header">
											<h5>Resourse Topics</h5>
											<button
												type="button"
												className="btn btn-icon mobile-menu-button block_sidebar-nav-header-close"
												onClick={callMenu}
											>
												<img
													className="btn-icon-image_hover"
													src={require('@app/images/close_white.svg')}
													alt="search"
													width="16"
												/>
											</button>
										</div>
										<ul className="block__sidebar-nav-list">
											{topics.map((item, index) => (
												<li key={index}>
													<a
														className={
															currentIndex === index
																? 'block__sidebar-nav-list-item active'
																: 'block__sidebar-nav-list-item'
														}
														onClick={() => onSetIssue(index)}
													>
														{item.caption}
													</a>
												</li>
											))}
										</ul>
									</>
								)}
								<div className="block__sidebar-nav-filter">
									<h4 className="block__sidebar-nav-filter-title">Filter by state</h4>
									<SearchFieldAuto
										name="state"
										placeholder="Select a state"
										listOptions={stateListOptions}
										formikBag={formikBag}
										onSelect={(value, option) => {
											setStateSelected && setStateSelected(value);
											setVetName && setVetName('');
											setVetId && setVetId('');
											setVetFieldValue && setVetFieldValue('');
											setVetNameShort && setVetNameShort('');
											formikBag.values.vetById = '';
											formikBag.values.vetByName = '';
										}}
										onChange={(value) => {
											formikBag.setFieldValue('state', value);
										}}
										searchButton={false}
									/>
									{!formikBag.values.vetByName && (
										<>
											<h4 className="block__sidebar-nav-filter-title">Filter by veterinarian</h4>
											<SearchFieldAuto
												name="vetById"
												placeholder="Select veterinarian"
												listOptions={vetListOptions}
												formikBag={formikBag}
												onSelect={(value, option) => {
													setVetId && setVetId(String(option?.id || ''));
												}}
												onChange={(value, option) => {
													setVetId && setVetId('');
													formikBag.setFieldValue('vetById', value);
													setVetFieldValue && setVetFieldValue(value);
												}}
												searchButton={false}
											/>
										</>
									)}
								</div>
								{withSubmit && (
									<>
										<div className=" block__sidebar-nav-clear">
											<button type="reset" onClick={() => clearSelected(formikBag)} className="btn btn-secondary">
												Clear all filters
											</button>
										</div>
										{typeButton === 'submit' ? (
											<button type="submit" className="btn btn-primary btn-submit">{submitCaption}</button>
										) : (
											<button type={typeButton} className="btn btn-primary btn-submit" onClick={onSubmit}>{submitCaption}</button>
										)}
									</>
								)}
							</div>
						</Form>
					);
				}}
			</Formik>
		</div>
	);
};

export default Sidebar;
